import { render, staticRenderFns } from "./PnlHistory.vue?vue&type=template&id=244c1681&scoped=true&lang=pug"
import script from "./PnlHistory.vue?vue&type=script&lang=js"
export * from "./PnlHistory.vue?vue&type=script&lang=js"
import style0 from "./PnlHistory.vue?vue&type=style&index=0&id=244c1681&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c1681",
  null
  
)

export default component.exports